import { render } from "./CommentActivityView.vue?vue&type=template&id=64d9701d&scoped=true"
import script from "./CommentActivityView.vue?vue&type=script&lang=js"
export * from "./CommentActivityView.vue?vue&type=script&lang=js"

import "./CommentActivityView.vue?vue&type=style&index=0&id=64d9701d&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d9701d"]])

export default __exports__